import { render, staticRenderFns } from "./PasswordResetPerform.vue?vue&type=template&id=4f9fd503&scoped=true&"
import script from "./PasswordResetPerform.vue?vue&type=script&lang=js&"
export * from "./PasswordResetPerform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9fd503",
  null
  
)

export default component.exports